var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? "修改" : "新增",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "展示名称", prop: "show_name" } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "请输入展示名称(用于后台)"
                },
                model: {
                  value: _vm.form.show_name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "show_name", $$v)
                  },
                  expression: "form.show_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "服务器", prop: "game_server_id" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", filterable: "" },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.form.game_server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "game_server_id", $$v)
                    },
                    expression: "form.game_server_id"
                  }
                },
                _vm._l(_vm.GamesServersList, function(item, index) {
                  return _c(
                    "el-option",
                    {
                      key: index,
                      attrs: { label: item.show_name, value: item.id }
                    },
                    [
                      _vm._v(
                        _vm._s(item.game_show_name + " - " + item.show_name)
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "货币类型", prop: "currency" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.form.currency,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "currency", $$v)
                  },
                  expression: "form.currency"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "折扣", prop: "discount" } },
            [
              _c("el-input", {
                attrs: { maxlength: 4, clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.form.discount,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "discount", $$v)
                  },
                  expression: "form.discount"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "价格(分)", prop: "price" } },
            [
              _c("el-input", {
                attrs: { type: "number", clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.form.price,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "price", _vm._n($$v))
                  },
                  expression: "form.price"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "研发商品", prop: "cp_product" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入研发商品" },
                model: {
                  value: _vm.form.cp_product,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "cp_product", $$v)
                  },
                  expression: "form.cp_product"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "state" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.state,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "state", $$v)
                    },
                    expression: "form.state"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 2, border: "" } }, [
                    _vm._v("启用")
                  ]),
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("禁用")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "返利比", prop: "welfare" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入返利比" },
                model: {
                  value: _vm.form.welfare,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "welfare", $$v)
                  },
                  expression: "form.welfare"
                }
              })
            ],
            1
          ),
          _vm.form.id
            ? _c(
                "el-form-item",
                { attrs: { label: "是否定时修改" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.dingshi,
                        callback: function($$v) {
                          _vm.dingshi = $$v
                        },
                        expression: "dingshi"
                      }
                    },
                    _vm._l(_vm.dingshiList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.dingshi == 2
            ? _c(
                "el-form-item",
                { attrs: { label: "定时时间", prop: "delay_time" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      type: "datetime",
                      "value-format": "timestamp",
                      placeholder: "请选择",
                      align: "right"
                    },
                    model: {
                      value: _vm.form.delay_time,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "delay_time", _vm._n($$v))
                      },
                      expression: "form.delay_time"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.reqtype == "Normal" && _vm.form.discount != 1
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "限制规则" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "" },
                        model: {
                          value: _vm.form.restriction_type,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "restriction_type", $$v)
                          },
                          expression: "form.restriction_type"
                        }
                      },
                      _vm._l(_vm.limitationList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "折扣次数", prop: "restriction_num" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入次数" },
                      model: {
                        value: _vm.form.restriction_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "restriction_num", $$v)
                        },
                        expression: "form.restriction_num"
                      }
                    })
                  ],
                  1
                ),
                _vm.form.restriction_type == 4
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "活动时间", prop: "dateVal" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            type: "daterange",
                            align: "right",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期"
                          },
                          model: {
                            value: _vm.dateVal,
                            callback: function($$v) {
                              _vm.dateVal = $$v
                            },
                            expression: "dateVal"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "是否随机赠送", prop: "state" }
            },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.handleRandGiveSwitchChange },
                  model: {
                    value: _vm.form.rand_give_switch,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "rand_give_switch", $$v)
                    },
                    expression: "form.rand_give_switch"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 0, border: "" } }, [
                    _vm._v("无")
                  ]),
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("固定")
                  ]),
                  _c("el-radio", { attrs: { label: 2, border: "" } }, [
                    _vm._v("档位")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm.form.rand_give_switch == 1
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "随机赠送配置", prop: "rand_give_txt" } },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "10",
                        clearable: "",
                        placeholder: "请输入"
                      },
                      model: {
                        value: _vm.form.rand_give_txt,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "rand_give_txt", $$v)
                        },
                        expression: "form.rand_give_txt"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "随机赠送时间", prop: "dateVal1" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        type: "datetimerange",
                        align: "right",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期"
                      },
                      model: {
                        value: _vm.dateVal1,
                        callback: function($$v) {
                          _vm.dateVal1 = $$v
                        },
                        expression: "dateVal1"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.form.rand_give_switch == 2
            ? [
                _c(
                  "el-row",
                  { staticStyle: { width: "100%", "margin-bottom": "0" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "lodingItem",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.addGiveContent()
                              }
                            }
                          },
                          [_vm._v("添加赠送例配置字段")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._l(_vm.form.rand_give_gear, function(domain, index) {
                  return _c(
                    "div",
                    { key: index + "k", staticStyle: { width: "100%" } },
                    [
                      _c(
                        "div",
                        { staticClass: "lodingItem-operationFrame  x-c" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              staticStyle: { "margin-right": "20px" },
                              attrs: {
                                "label-width": "0",
                                prop: "rand_give_gear." + index + ".label",
                                rules: _vm.rules.value
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "请输入" },
                                model: {
                                  value: domain.label,
                                  callback: function($$v) {
                                    _vm.$set(domain, "label", $$v)
                                  },
                                  expression: "domain.label"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              attrs: {
                                "label-width": "0",
                                prop: "rand_give_gear." + index + ".value",
                                rules: _vm.rules.value
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "请输入" },
                                model: {
                                  value: domain.value,
                                  callback: function($$v) {
                                    _vm.$set(domain, "value", $$v)
                                  },
                                  expression: "domain.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticStyle: { margin: "0 10px 24px 10px" },
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeGiveContent(domain)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                })
              ]
            : _vm._e(),
          _vm.reqtype == "vip"
            ? [
                _c(
                  "el-row",
                  { staticStyle: { width: "100%", "margin-bottom": "0" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "lodingItem",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.addLanContent()
                              }
                            }
                          },
                          [_vm._v("添加语言")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      display: "flex",
                      "justify-content": "space-between",
                      "flex-wrap": "wrap",
                      "flex-direction": "column"
                    }
                  },
                  _vm._l(_vm.form.languageManage, function(itemA, idx) {
                    return _c(
                      "div",
                      { key: "lang-" + idx },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "请选择语言",
                                  prop: "languageManage." + idx + ".language",
                                  rules: _vm.rules.language
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { filterable: "" },
                                    model: {
                                      value: itemA.language,
                                      callback: function($$v) {
                                        _vm.$set(itemA, "language", $$v)
                                      },
                                      expression: "itemA.language"
                                    }
                                  },
                                  _vm._l(_vm.languageList, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.sign
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _c("el-button", {
                              staticStyle: { margin: "0 10px 24px 10px" },
                              attrs: {
                                size: "mini",
                                type: "danger",
                                circle: "",
                                icon: "el-icon-plus"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.addContent(itemA)
                                }
                              }
                            }),
                            _c("el-button", {
                              staticStyle: { margin: "0 10px 24px 10px" },
                              attrs: {
                                size: "mini",
                                type: "danger",
                                circle: "",
                                icon: "el-icon-delete"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeLanContent(itemA)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(itemA.list, function(itemb, ina) {
                          return _c(
                            "div",
                            {
                              key: ina,
                              staticStyle: {
                                width: "100%",
                                display: "flex",
                                "justify-content": "space-between",
                                "flex-wrap": "wrap"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "text-align": "right",
                                    "margin-bottom": "10px"
                                  }
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      circle: "",
                                      icon: "el-icon-delete"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.removecontent(idx, ina)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商品名称",
                                    prop:
                                      "languageManage." +
                                      idx +
                                      ".list." +
                                      ina +
                                      ".product_name",
                                    rules: _vm.rules.product_name
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请输入"
                                    },
                                    model: {
                                      value: itemb.product_name,
                                      callback: function($$v) {
                                        _vm.$set(itemb, "product_name", $$v)
                                      },
                                      expression: "itemb.product_name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商品简介",
                                    prop:
                                      "languageManage." +
                                      idx +
                                      ".list." +
                                      ina +
                                      ".content",
                                    rules: _vm.rules.content
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请输入商品简介"
                                    },
                                    model: {
                                      value: itemb.content,
                                      callback: function($$v) {
                                        _vm.$set(itemb, "content", $$v)
                                      },
                                      expression: "itemb.content"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    label: "宣传图",
                                    prop:
                                      "languageManage." +
                                      idx +
                                      ".list." +
                                      ina +
                                      ".icon",
                                    rules: _vm.rules.icon
                                  }
                                },
                                [
                                  _c("uploadImage", {
                                    attrs: {
                                      value: itemb.picfileList,
                                      fileType: ["png", "jpg", "jpeg", "gif"],
                                      fileSize: 40
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.imgChange1($event, idx, ina)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    label: "预览图",
                                    prop:
                                      "languageManage." +
                                      idx +
                                      ".list." +
                                      ina +
                                      ".iconPrev",
                                    rules: _vm.rules.iconPrev
                                  }
                                },
                                [
                                  _c("uploadImage", {
                                    attrs: {
                                      value: itemb.prepicfileList,
                                      fileType: ["png", "jpg", "jpeg", "gif"],
                                      fileSize: 40
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.imgChangePre(
                                          $event,
                                          idx,
                                          ina
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            : _vm._e(),
          _vm.reqtype == "Normal"
            ? _vm._l(_vm.form.params, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: {
                      width: "100%",
                      display: "flex",
                      "justify-content": "space-between",
                      "flex-wrap": "wrap"
                    }
                  },
                  [
                    _c("div", { staticClass: "langTitle" }, [
                      _vm._v(" " + _vm._s(item.languageName) + " ")
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "商品名称",
                          prop: "params." + index + ".product_name",
                          rules: _vm.rules.product_name
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "请输入" },
                          model: {
                            value: item.product_name,
                            callback: function($$v) {
                              _vm.$set(item, "product_name", $$v)
                            },
                            expression: "item.product_name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "商品简介",
                          prop: "params." + index + ".content",
                          rules: _vm.rules.content
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            clearable: "",
                            placeholder: "请输入商品简介"
                          },
                          model: {
                            value: item.content,
                            callback: function($$v) {
                              _vm.$set(item, "content", $$v)
                            },
                            expression: "item.content"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          label: "宣传图",
                          prop: "params." + index + ".icon",
                          rules: _vm.rules.icon
                        }
                      },
                      [
                        _c("uploadImage", {
                          attrs: { value: item.picfileList },
                          on: {
                            input: function($event) {
                              return _vm.imgChange($event, item, index)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            : _vm._e()
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogShow = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(true)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }